module.exports = __webpack_public_path__ + "static/save-60a776fb36315c2e02895524c1d80491.jpg";